import { createMuiTheme } from '@material-ui/core/styles';

/** Brand-aligned MUI theme — primary matches site (#1760d3). */
const theme = createMuiTheme({
  palette: {
    primary: { main: '#1760d3' },
    secondary: { main: '#17dddd' },
    text: {
      primary: '#1a1a1a',
      secondary: '#5c5c5c',
    },
    background: { default: '#ffffff', paper: '#f8fafc' },
  },
  typography: {
    fontFamily: '"Lato", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
    h1: { fontWeight: 600, letterSpacing: '0.02em' },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: { borderRadius: 8 },
  overrides: {
    MuiButton: {
      root: { borderRadius: 8 },
    },
    MuiCard: {
      root: { borderRadius: 12 },
    },
  },
});

export default theme;
